

        jQuery(function() {
            var $hero = jQuery('#m-1528927431584');
            var $module = jQuery('#m-1528927431584').children('.module');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'dev') {
                $hero.children('.hero-link').hide();
            }

            var height = $.trim($module.attr('data-height'));
            if(height == undefined || height == '') {
                $hero.attr('style', 'height: auto!important');
                jQuery(window).resize(function(){
                    $hero.attr('style', 'height: auto!important');
                });
            } else {
                $hero.removeAttr('style');
            }

            var effect = $module.attr('data-effect');
            var transition = $module.attr('data-transition');

            if(effect == 'effect-zoom') {   
                $module.parent().addClass(effect);

                var backgroundImage = $module.parent().css('background-image');
                var backgroundSize = $module.parent().css('background-size');
                var backgroundPosition = $module.parent().css('background-position');

                $module.siblings('.gf_hero-bg-wrap').children('.gf_hero-bg').css({
                    'background-image'      : backgroundImage,
                    'background-size'       : backgroundSize,
                    'background-position'   : backgroundPosition,
                    '-webkit-transition'    : 'transform ' + transition + 's ease-in-out',
                    '-moz-transition'       : 'transform ' + transition + 's ease-in-out',
                    '-ms-transition'        : 'transform ' + transition + 's ease-in-out',
                    '-o-transition'         : 'transform ' + transition + 's ease-in-out',
                    'transition'            : 'transform ' + transition + 's ease-in-out'
                });
            }

            if($module.attr('data-fixedMode') == '1'){
                $module.parent().attr('style', 'padding-top: 0px!important; padding-bottom: 0px!important; height: auto!important; background-image: none!important;max-width: 100%!important;');

                jQuery(window).resize(function(){
                    var backgroundImage =  $module.parent().css('background-image');
                    $module.parent().attr('style', 'padding-top: 0px!important; padding-bottom: 0px!important; height: auto!important; background-image: none!important;max-width: 100%!important;');
                });
            } else {
                $module.parent().removeAttr('style');
            }
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1528927396833').children('.module');   
            var navspeed = $module.data('navspeed'),
                margin = parseInt($module.data('margin')),
                autoplaytimeout = $module.data('autoplaytimeout'),
                autoplayhoverpause = $module.data('autoplayhoverpause'),
                navlg = $module.data('navlg'),
                navmd = $module.data('navmd'),
                navsm = $module.data('navsm'),
                navxs = $module.data('navxs'),
                collg = $module.data('collg'),
                colmd = $module.data('colmd'),
                colsm = $module.data('colsm'),
                colxs = $module.data('colxs'),
                dotslg = $module.data('dotslg'),
                dotsmd = $module.data('dotsmd'),
                dotssm = $module.data('dotssm'),
                dotsxs = $module.data('dotsxs');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'production') {
                var autoplay = $module.data('autoplay'), 
                    loop = $module.data('loop');
            } else {
                var autoplay = 0, 
                    loop = 0;
            }
        
            $module.owlCarousel({
                margin: margin,
                mouseDrag: false,
                autoplayHoverPause: autoplayhoverpause,
                autoplay: autoplay,
                autoplayTimeout: autoplaytimeout,
                loop: loop,
                navSpeed: navspeed,
                autoWidth: !1,
                responsiveClass:true,
                responsive:{
                    0:{
                        items:colxs,
                        nav: navxs,
                        dots:dotsxs
                    },
                    768:{
                        items:colsm,
                        nav: navsm,
                        dots:dotssm
                    },
                    992:{
                        items:colmd,
                        nav: navmd,
                        dots:dotsmd
                    },
                    1200:{
                        items:collg,
                        nav: navlg,
                        dots:dotslg
                    }
                }
            }); 
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081318').children('.module');   
            var columns = $module.data('columns'),
                nav = $module.data('nav'), 
                navspeed = $module.data('navspeed'), 
                dots = $module.data('dots'),
                center = $module.data('center'),
                autoplaytimeout = $module.data('autoplaytimeout'),
                autoplayhoverpause = $module.data('autoplayhoverpause');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'production') {
                var autoplay = $module.data('autoplay'), 
                    loop = $module.data('loop');
            } else {
                var autoplay = 0, 
                    loop = 0;
            }
        
            $module.owlCarousel({
                mouseDrag: false,
                nav: nav,
                dots: dots,
                autoplayHoverPause: autoplayhoverpause,
                autoplay: autoplay,
                autoplayTimeout: autoplaytimeout,
                center: center,
                loop: loop,
                navSpeed: navspeed,
                autoWidth: !1,
                items: columns,
                responsive: {
                    0: {
                        items: 1,
                        nav: nav, 
                        dots: false 
                    },
                    700: {
                        items: columns,
                        nav: nav, 
                        dots: dots 
                    },
                    1000: {      
                        items: columns,
                        nav: nav, 
                        dots: dots,
                    },
                    1200: {      
                        items: columns,
                        nav: nav, 
                        dots: dots 
                    }
                }
            }); 
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081374').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081374-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081366').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081340').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081324').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081324-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081353').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081371').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081395').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081395-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081419').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081331').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081323').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081323-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081336').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081338').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081401').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081401-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081341').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081332').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081352').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081352-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081295').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081345').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081376').children('.module');
            var click2cart = $module.data('click2cart') != undefined ? $module.data('click2cart') : false;
            $module.gfV3Product({
                'click2cart': click2cart
            });
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081376-0').children('.module');
            var zoom = $module.attr('data-zoom');

            $module.gfV3ProductImage({
                'zoom': zoom
            })
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081329').children('.module');
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081416').children('.module');
            $module.gfV3ProductPrice();
        }); 
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081315').children('.module');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'dev') {
                $module.children('.hero-link').hide();
            }

            if($module.attr('data-fullheight') == '1' ){
                var wHeight = jQuery(window).height();
                $module.css({
                    'height': wHeight
                });
                jQuery(window).resize(function(){
                    $module.css('height', jQuery(window).height());
                });
                $module.addClass('full-height');
            } else {
                $module.css({
                    'height': 'auto'
                });
                jQuery(window).resize(function(){
                    $module.css('height', 'auto');
                });
                $module.removeClass('full-height');
            }

            var effect = $module.attr('data-effect');
            var transition = $module.attr('data-transition');
            if(effect == 'effect-zoom') {   
                $module.parent().addClass(effect);

                var backgroundImage = $module.parent().css('background-image');
                var backgroundSize = $module.parent().css('background-size');
                var backgroundPosition = $module.parent().css('background-position');

                $module.children('.gf_hero-bg').css({
                    'background-image'      : backgroundImage,
                    'background-size'       : backgroundSize,
                    'background-position'   : backgroundPosition,
                    '-webkit-transition'    : 'transform ' + transition + 's ease-in-out',
                    '-moz-transition'       : 'transform ' + transition + 's ease-in-out',
                    '-ms-transition'        : 'transform ' + transition + 's ease-in-out',
                    '-o-transition'         : 'transform ' + transition + 's ease-in-out',
                    'transition'            : 'transform ' + transition + 's ease-in-out'
                });
            }
        });
    
        jQuery(function() {
            function gfYoutubeIframe(settings){
                var iframeHtml = 'Error! Cannot generate youtube video.';
                if(settings.url != undefined) {
                    var url = settings.url.split(/watch\?v=/);
                    if(url) {
                        iframeHtml = '';
                        if(settings.responsive == '1') {
                            iframeHtml += '<style>.gempage-video{position:relative;width:100%;height:0;padding-bottom:56.27198%;}.gempage-video iframe{position:absolute;top:0;left:0;width:100%;height:100%;}</style><div class="gempage-video">';
                        }
                        var url = 'https://www.youtube.com/embed/' + url[1] + '?1=1';
                        if(settings.autoplay == '1') {
                            url += '&amp;autoplay=1';
                        }
                        if(settings.controls == '0') {
                            url += '&amp;controls=0';
                        }
                        if(settings.showinfo == '0') {
                            url += '&amp;showinfo=0';
                        }
                        if(settings.modestbranding == '1') {
                            url += '&amp;modestbranding=1';
                        }
                        if(settings.fs == '0') {
                            url += '&amp;fs=0';
                        }
                        if(settings.rel == '0') {
                            url += '&amp;rel=0';
                        }
                        if(settings.start != '') {
                            url += '&amp;start=' + parseInt(settings.start);
                        }
                        if(settings.end != '') {
                            url += '&amp;end=' + parseInt(settings.end);
                        }
                        if(settings.hd == '1') {
                            url += '&amp;hd=1';
                        }
                        iframeHtml += '<iframe width="' + settings.width + '" height="' + settings.height + '" src="' + url + '" frameborder="0"></iframe>';
                        if(settings.responsive == '1') {
                            iframeHtml += '</div><div style="font-size: 0.8em"></div>';
                        }
                    }
                }
                return iframeHtml;
            }

            var $module = jQuery('#m-1508410081301').children('.module');
            var settings = {};
            if($module.attr('data-url') != undefined) {
                settings.url = $module.attr('data-url');
            }
            settings.width = 500;
            if($module.attr('data-width') != undefined && $module.attr('data-width') != '' && $module.attr('data-width') != 'auto') {
                settings.width = parseInt($module.attr('data-width'));
            }
            settings.height = 294;
            if($module.attr('data-height') != undefined && $module.attr('data-height') != '' && $module.attr('data-height') != 'auto') {
                settings.height = parseInt($module.attr('data-height'));
            }
            settings.responsive = 1;
            if($module.attr('data-responsive') != undefined) {
                settings.responsive = $module.attr('data-responsive');
            }
            settings.autoplay = 0;
            if($module.attr('data-autoplay') != undefined) {
                settings.autoplay = $module.attr('data-autoplay');
            }
            settings.controls = 1;
            if($module.attr('data-controls') != undefined) {
                settings.controls = $module.attr('data-controls');
            }
            settings.showinfo = 1;
            if($module.attr('data-showinfo') != undefined) {
                settings.showinfo = $module.attr('data-showinfo');
            }
            settings.autoplay = 0;
            if($module.attr('data-autoplay') != undefined) {
                settings.autoplay = $module.attr('data-autoplay');
            }
            settings.modestbranding = 0;
            if($module.attr('data-modestbranding') != undefined) {
                settings.modestbranding = $module.attr('data-modestbranding');
            }
            settings.fs = 0;
            if($module.attr('data-fs') != undefined) {
                settings.fs = $module.attr('data-fs');
            }
            settings.rel = 1;
            if($module.attr('data-rel') != undefined) {
                settings.rel = $module.attr('data-rel');
            }
            settings.hd = 1;
            if($module.attr('data-hd') != undefined) {
                settings.hd = $module.attr('data-hd');
            }
            settings.start = '';
            if($module.attr('data-start') != undefined) {
                settings.start = $module.attr('data-start');
            }
            settings.end = '';
            if($module.attr('data-end') != undefined) {
                settings.end = $module.attr('data-end');
            }

            setTimeout(function() {
                var embedIframe = gfYoutubeIframe(settings);
                $module.html(embedIframe);
            }, 100);
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081310').children('.module');
        
            var token_test = '2269641474.1677ed0.63eaaf968720481a866e9263fc8639e1';
            var token = $module.data('token') != '' ? $module.data('token') : token_test;
            var num_photos = parseInt($module.data('photos')) > 1 ? parseInt($module.data('photos')) : 1;
            var num_columns = parseInt($module.data('columns')) > 1 ? parseInt($module.data('columns')) : num_photos;
            var padding = parseInt($module.data('padding')) > 0 ? parseInt($module.data('padding')) : 0;

            var instaTag = jQuery.trim($module.data('hashtag')) != '' ? jQuery.trim($module.data('hashtag')) : '';

            if(instaTag != '') {
                var instaUrl = 'https://api.instagram.com/v1/tags/' + instaTag + '/media/recent';
            } else {
                var instaUrl = 'https://api.instagram.com/v1/users/self/media/recent';
            }

            jQuery.ajax({
                url: instaUrl,
                dataType: 'jsonp',
                type: 'GET',
                data: {
                    access_token: token, 
                    count: num_photos
                },
                success: function(data) {
                    var html = '';
                    if(data.data != undefined) {
                        for(var i = 0; i < data.data.length; i++) {
                            if(i % num_columns == 0) {
                                html += '<div class="gf_clearfix"></div>';
                            }
                            html += '<li><a href="' + data.data[i].link + '" target="_blank" style="padding: ' + padding + 'px;">';
                                html+= '<img src="'+ data.data[i]['images'].standard_resolution.url + '" alt="' + data.data[i].caption + '" />';
                            html += '</a></li>';
                        }
                        $module.html(html).hide();
                        $module.find('li').css('width', (100/num_columns)+'%');

                        $module.closest('.module-wrap').css('marginLeft', padding * -1);
                        $module.closest('.module-wrap').css('marginRight', padding * -1);
                    }
                    $module.fadeIn();
                },
                error: function(data){
                    console.log(data);
                }
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081303').children('.module');
        
            var token_test = '2269641474.1677ed0.63eaaf968720481a866e9263fc8639e1';
            var token = $module.data('token') != '' ? $module.data('token') : token_test;
            var num_photos = parseInt($module.data('photos')) > 1 ? parseInt($module.data('photos')) : 1;
            var num_columns = parseInt($module.data('columns')) > 1 ? parseInt($module.data('columns')) : num_photos;
            var padding = parseInt($module.data('padding')) > 0 ? parseInt($module.data('padding')) : 0;

            var instaTag = jQuery.trim($module.data('hashtag')) != '' ? jQuery.trim($module.data('hashtag')) : '';

            if(instaTag != '') {
                var instaUrl = 'https://api.instagram.com/v1/tags/' + instaTag + '/media/recent';
            } else {
                var instaUrl = 'https://api.instagram.com/v1/users/self/media/recent';
            }

            jQuery.ajax({
                url: instaUrl,
                dataType: 'jsonp',
                type: 'GET',
                data: {
                    access_token: token, 
                    count: num_photos
                },
                success: function(data) {
                    var html = '';
                    if(data.data != undefined) {
                        for(var i = 0; i < data.data.length; i++) {
                            if(i % num_columns == 0) {
                                html += '<div class="gf_clearfix"></div>';
                            }
                            html += '<li><a href="' + data.data[i].link + '" target="_blank" style="padding: ' + padding + 'px;">';
                                html+= '<img src="'+ data.data[i]['images'].standard_resolution.url + '" alt="' + data.data[i].caption + '" />';
                            html += '</a></li>';
                        }
                        $module.html(html).hide();
                        $module.find('li').css('width', (100/num_columns)+'%');

                        $module.closest('.module-wrap').css('marginLeft', padding * -1);
                        $module.closest('.module-wrap').css('marginRight', padding * -1);
                    }
                    $module.fadeIn();
                },
                error: function(data){
                    console.log(data);
                }
            });
        });
    
        jQuery(function() {
            var $module = jQuery('#m-1508410081365').children('.module');

            var mode = jQuery('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
            if(mode == 'dev') {
                $module.children('.hero-link').hide();
            }

            if($module.attr('data-fullheight') == '1' ){
                var wHeight = jQuery(window).height();
                $module.css({
                    'height': wHeight
                });
                jQuery(window).resize(function(){
                    $module.css('height', jQuery(window).height());
                });
                $module.addClass('full-height');
            } else {
                $module.css({
                    'height': 'auto'
                });
                jQuery(window).resize(function(){
                    $module.css('height', 'auto');
                });
                $module.removeClass('full-height');
            }

            var effect = $module.attr('data-effect');
            var transition = $module.attr('data-transition');
            if(effect == 'effect-zoom') {   
                $module.parent().addClass(effect);

                var backgroundImage = $module.parent().css('background-image');
                var backgroundSize = $module.parent().css('background-size');
                var backgroundPosition = $module.parent().css('background-position');

                $module.children('.gf_hero-bg').css({
                    'background-image'      : backgroundImage,
                    'background-size'       : backgroundSize,
                    'background-position'   : backgroundPosition,
                    '-webkit-transition'    : 'transform ' + transition + 's ease-in-out',
                    '-moz-transition'       : 'transform ' + transition + 's ease-in-out',
                    '-ms-transition'        : 'transform ' + transition + 's ease-in-out',
                    '-o-transition'         : 'transform ' + transition + 's ease-in-out',
                    'transition'            : 'transform ' + transition + 's ease-in-out'
                });
            }
        });
    
        jQuery(function() {
          var $module = jQuery('#m-1508410081334').children('.module');
        });
    